import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css'
import { FormControl, InputGroup, OverlayTrigger, Popover } from 'react-bootstrap';
import { ApplyFilter } from "../TableIndex";

const ROLE_FILTER_OPTIONS = [
  { id: '4', label: 'Clinician' },
  { id: '5', label: 'Supervisor' },
  { id: '3', label: 'Practice Administrator' },
];

function FilterModal(props) { 
  const {fetchUser, roleFilter, dateFilter} = useContext(ApplyFilter);

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(null);

  const [startDateVal, setStartDateVal] = useState(false);
  const [endDateVal, setEndDateVal] = useState(false);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [DateRangeValue, setDateRangeValue] = useState('Select Start To End Date');
  
  const onChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end); 

    setStartDateVal(moment(start).format('YYYY-MM-DD'));
    if(end){
      setEndDateVal(moment(end).format('YYYY-MM-DD'));
    }    
  };

  const toggleRole = (roleId) => {
    setSelectedRoles((prev) =>
      prev.includes(roleId)
        ? prev.filter((id) => id !== roleId)
        : [...prev, roleId]
    );
  };
  
  const FilterAppply = () => {
    const hasDateRange = Boolean(startDateVal && endDateVal);
    const hasRoles = selectedRoles.length > 0;
    if (hasDateRange || hasRoles) {
      fetchUser({
        from_date: startDateVal || undefined,
        to_date: endDateVal || undefined,
        user_role: hasRoles ? selectedRoles.join(',') : undefined,
      });
      props.close();
    }
  }

  const ClearFilter = () => {
    window.location.reload();
  }


  useEffect(() => {
    let start = startDateVal ? startDateVal : 'Start Date';
    let end = endDateVal ? endDateVal : 'End Date'
    setDateRangeValue(start+' - '+end)
    return () => {
      //cleanup
    }
  }, [startDateVal, endDateVal])

  const popoverDate = (
          <Popover id="popover-basic">
              <DatePicker       
                selected={startDate}         
                onChange={onChange}
                startDate={startDate}
                endDate={endDate}
                selectsRange
                inline
              />
          </Popover>
  );
  return (
    <>
      {
        dateFilter 
        ?
          <div>                
                <InputGroup className="mb-3">
                  <OverlayTrigger trigger="click" placement="right" overlay={popoverDate} rootClose>                    
                          <FormControl                   
                            style={{ color: '#a1a5b7' }}
                            placeholder="Select Date Range"
                            aria-label="Select Date Range"
                            value={DateRangeValue}
                            readOnly
                          />                                        
                </OverlayTrigger>
              </InputGroup>
          </div> 
        : ""
      }
      {
        roleFilter
        ? <div className="my-2">
          <div className="fw-bolder text-dark mb-2">Filter by role</div>
          {ROLE_FILTER_OPTIONS.map((role) => (
            <div className="form-check mb-2" key={role.id}>
              <input
                className="form-check-input"
                type="checkbox"
                id={`filter-role-${role.id}`}
                checked={selectedRoles.includes(role.id)}
                onChange={() => toggleRole(role.id)}
              />
              <label className="form-check-label" htmlFor={`filter-role-${role.id}`}>
                {role.label}
              </label>
            </div>
          ))}
        </div>
        : ""
      }      
      <div>
        <div className="btn btn-primary" onClick={() => FilterAppply()}>Apply</div>    
        &nbsp;
        <div className="btn btn-warning" onClick={() => ClearFilter()}>Clear Filter</div>
      </div>
    </>
  );
}

export default FilterModal;
